import { useMemo, useState } from "react";
import { useEarlyFreedomBaseline } from "web_myplann/Inspiration/Hooks/useEarlyFreedomBaseline";
import {
	computeEarlyFreedomContext,
	type EarlyFreedomInputs,
} from "web_myplann/Inspiration/Utils/earlyFreedomMath";

export type EarlyFreedomSheet = "quick" | "income" | null;

export const useEarlyFreedomJourney = () => {
	const { age, monthlySaving } = useEarlyFreedomBaseline();
	const [inputs, setInputs] = useState<EarlyFreedomInputs>({});
	const [activeSheet, setActiveSheet] = useState<EarlyFreedomSheet>(null);

	const context = useMemo(
		() => computeEarlyFreedomContext(inputs, { age, monthlySaving }),
		[inputs, age, monthlySaving],
	);

	const submitQuick = (targetExpenses: number) => {
		setInputs((prev) => ({ ...prev, targetExpenses }));
		setActiveSheet(null);
	};

	const submitIncome = (rentNet: number) => {
		setInputs((prev) => ({ ...prev, rentNet }));
		setActiveSheet(null);
	};

	const setTargetExpenses = (targetExpenses: number) =>
		setInputs((prev) => ({ ...prev, targetExpenses }));

	const setMonthlySaving = (monthlySaving: number) =>
		setInputs((prev) => ({ ...prev, monthlySaving }));

	return {
		context,
		inputs,
		activeSheet,
		openSheet: setActiveSheet,
		closeSheet: () => setActiveSheet(null),
		submitQuick,
		submitIncome,
		setTargetExpenses,
		setMonthlySaving,
	};
};
